const getPercentageSavings = (pricePerPoint: number): string => {
  if (pricePerPoint === 0 || pricePerPoint === 0.66) {
    return ''
  }
  const percentage = Math.ceil(100 - (pricePerPoint / 0.66) * 100)
  return `${percentage}% SAVINGS!`
}

export default getPercentageSavings
